__turbopack_context__.v({
  "folderMiddleSegment": "AssetListItem-module__n50tkG__folderMiddleSegment",
  "folderRestrictionBadge": "AssetListItem-module__n50tkG__folderRestrictionBadge",
  "folderWrapper": "AssetListItem-module__n50tkG__folderWrapper",
  "restrictedFolderLabel": "AssetListItem-module__n50tkG__restrictedFolderLabel",
});
